import { breakpoints, operators } from './store';

// Cache per le query media e i listener
const mediaCache = new Map();
const mediaCallbacks = new Map();
let resizeListenerAdded = false;

export function media(expression1, expression2 = null, callback = null) {
    const query = media_expression(expression1, expression2);
    
    // Se la query è già in cache, restituisci il valore cached
    if (mediaCache.has(query)) {
        const cachedQuery = mediaCache.get(query);
        // Se c'è un callback, aggiungilo alla lista
        if (callback) {
            if (!mediaCallbacks.has(query)) {
                mediaCallbacks.set(query, new Set());
            }
            mediaCallbacks.get(query).add(callback);
        }
        return cachedQuery.matches;
    }
    
    // Crea la MediaQueryList
    const mediaQuery = window.matchMedia(query);
    
    // Aggiungi alla cache
    mediaCache.set(query, mediaQuery);
    
    // Aggiungi il callback se fornito
    if (callback) {
        if (!mediaCallbacks.has(query)) {
            mediaCallbacks.set(query, new Set());
        }
        mediaCallbacks.get(query).add(callback);
    }
    
    // Aggiungi il listener resize solo una volta
    if (!resizeListenerAdded) {
        window.addEventListener('resize', () => {
            // Aggiorna tutte le query cached e notifica i callback
            mediaCache.forEach((mq, queryKey) => {
                // Forza il refresh della MediaQueryList
                const newMediaQuery = window.matchMedia(mq.media);
                const oldMatches = mq.matches;
                const newMatches = newMediaQuery.matches;
                
                // Aggiorna la cache con la nuova MediaQueryList
                mediaCache.set(queryKey, newMediaQuery);
                
                // Se il valore è cambiato, notifica i callback
                if (oldMatches !== newMatches) {
                    const callbacks = mediaCallbacks.get(queryKey);
                    if (callbacks) {
                        callbacks.forEach(cb => cb(newMatches));
                    }
                }
            });
        });
        resizeListenerAdded = true;
    }
    
    return mediaQuery.matches;
}

// Funzione per pulire la cache (opzionale, per cleanup)
export function clearMediaCache() {
    mediaCache.clear();
    mediaCallbacks.clear();
    resizeListenerAdded = false;
}

// Funzione per rimuovere un callback specifico
export function removeMediaCallback(expression1, expression2 = null, callback) {
    const query = media_expression(expression1, expression2);
    const callbacks = mediaCallbacks.get(query);
    if (callbacks) {
        callbacks.delete(callback);
        if (callbacks.size === 0) {
            mediaCallbacks.delete(query);
        }
    }
}

export function media_expression(expression1, expression2 = null) {
    let template = null
    
    Object.keys(breakpoints).forEach((breakpoint)=> {
        let value = breakpoints[breakpoint];
        if(expression1.indexOf('=') == -1){
            if(expression1.indexOf('>') == -1){
                value = value - 1
            } else if (expression1.indexOf('<') == -1){
                value = value + 1
            }
        }
        expression1 = expression1.replace(new RegExp(breakpoint,'g'), value + 'px')
    })

    Object.keys(operators).forEach((operator)=> {
        expression1 = expression1.replace(new RegExp(operator,'g'), operators[operator])
    })

    if(expression2 != null){
        Object.keys(breakpoints).forEach((breakpoint)=> {
            let value = breakpoints[breakpoint];
            if(expression2.indexOf('=') == -1){
                if(expression2.indexOf('>') == -1){
                    value = value - 1
                } else if (expression2.indexOf('<') == -1){
                    value = value + 1
                }
            }
            expression2 = expression2.replace(new RegExp(breakpoint,'g'), value + 'px')
        })
    
        Object.keys(operators).forEach((operator)=> {
            expression2 = expression2.replace(new RegExp(operator,'g'), operators[operator])
        })
    }

    if (expression2 === null) {
        return `(${expression1})`
    } else {
        return `(${expression1}) and (${expression2})`
    }
}